import { ButtonColor } from '@design-system/components/button/button.css';
import { IconButton } from '@design-system/components/button/iconButton';
import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clsx } from 'clsx';

export const Header = ({
  title,
  link,
  cta,
}: {
  title: string;
  link?: string;
  cta?: Array<{
    icon: IconProp;
    onClick: () => void;
    content?: string;
    className?: string;
    disabled?: boolean;
    color?: ButtonColor;
  }>;
}) => (
  <div className="flex flex-col md:flex-row justify-between">
    <Typography variant="headline" size="large">
      {title}
    </Typography>
    {!link ? null : (
      <a
        className={clsx(
          'h-[36px] flex gap-2 items-center px-4 py-2 rounded-[10px] w-min',
          sprinkles({ color: 'W-100', bg: 'B-100' }),
        )}
        href={link}
        target="_blank"
        rel="noreferrer"
      >
        <FontAwesomeIcon
          icon={faArrowUpRightFromSquare}
          className="text-[14px]"
        />
        <Typography className="text-[14px] hidden md:inline-flex w-max">
          Open Creator Success Guide
        </Typography>
      </a>
    )}
    {!cta ? null : (
      <div className="flex gap-4">
        {cta.map((item, index) => (
          <IconButton
            key={index}
            disabled={item.disabled}
            icon={item.icon}
            color={item.color || 'neutral'}
            onClick={item.onClick}
          >
            {item.content || null}
          </IconButton>
        ))}
      </div>
    )}
  </div>
);
